import React, { useEffect, createElement } from 'react';
export function SEO() {
  useEffect(() => {
    // Set Title
    document.title = 'SEO PPC Co | Expert SEO & PPC Services in UK | Drive More Traffic & Leads';
    // Set Meta Description
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', "Transform your online presence with SEO PPC Co. UK's trusted digital marketing agency offering expert SEO, PPC management, and data-driven strategies. Get more traffic, leads & sales. Contact us on WhatsApp today!");
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = "Transform your online presence with SEO PPC Co. UK's trusted digital marketing agency offering expert SEO, PPC management, and data-driven strategies. Get more traffic, leads & sales. Contact us on WhatsApp today!";
      document.head.appendChild(meta);
    }
    // JSON-LD Schemas
    const schemas = [{
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'SEO PPC Co',
      url: 'https://seoppcco.com',
      logo: 'https://seoppcco.com/logo.png',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+44-7921-876472',
        contactType: 'customer service',
        areaServed: 'GB',
        availableLanguage: 'English'
      }
    }, {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'SEO PPC Co',
      image: 'https://seoppcco.com/logo.png',
      telephone: '+44-7921-876472',
      url: 'https://seoppcco.com',
      areaServed: 'United Kingdom',
      priceRange: '££'
    }, {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'SEO PPC Co',
      url: 'https://seoppcco.com',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://seoppcco.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string'
      }
    }, {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'SEO Services',
      provider: {
        '@type': 'Organization',
        name: 'SEO PPC Co'
      },
      areaServed: {
        '@type': 'Country',
        name: 'United Kingdom'
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Digital Marketing Services',
        itemListElement: [{
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'SEO Optimization'
          }
        }, {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'PPC Management'
          }
        }]
      }
    }, {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [{
        '@type': 'Question',
        name: 'What is SEO and why do I need it?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'SEO (Search Engine Optimization) is the process of improving your website to rank higher in search results like Google. You need it because higher rankings mean more visibility, more traffic, and ultimately more customers without paying for every click.'
        }
      }, {
        '@type': 'Question',
        name: 'How long does SEO take to show results?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'SEO is a long-term strategy. Typically, you can expect to see initial improvements in 3-4 months, with significant results in 6-12 months.'
        }
      }, {
        '@type': 'Question',
        name: "What's the difference between SEO and PPC?",
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'SEO focuses on earning traffic through organic (unpaid) search results, while PPC (Pay-Per-Click) involves buying traffic through paid ads.'
        }
      }]
    }];
    // Inject Schemas
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemas);
    document.head.appendChild(script);
    return () => {
      // Cleanup if needed (though usually fine to leave for SPA)
      document.head.removeChild(script);
    };
  }, []);
  return null;
}